import { InjectionToken } from '@angular/core';
import { BannerContent } from './banner.model';

export const BANNER_CONTENT = new InjectionToken<BannerContent>(
  'BannerContent'
);
